import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.scss";
import App from "./App";
import * as Constants from "./utils/constants";
import { ModalProvider } from 'meitav-uikit';


window.sitekey = Constants.RECAPTCHA_CURRENT_ENV;
// const recapchaScript = document.createElement("script");
// recapchaScript.src = `https://www.google.com/recaptcha/enterprise.js?render=${Constants.RECAPTCHA_DEV}`;
// document.head.appendChild(recapchaScript);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<ModalProvider>
        <App  />
    </ModalProvider>
);
